import React from 'react';

/**
 * @description right background pattern
 *  - This is used in the job filter page
 *  - The box background seen on the right side of the section
 * @returns {JSX.Element}
 */
function RightBackgroundPattern() {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='90'
			height='213'
			fill='none'
			viewBox='0 0 90 213'
		>
			<path
				fill='#FA3273'
				d='M52.119 1.739c-3.894 2.978-4.206 8.308-1.636 12.227C64.815 35.678 72.681 61.78 72.76 87.88c.078 27.277-9.269 53.143-26.949 73.836-12.072 14.108-26.949 25.474-42.214 35.82-9.269 6.271 1.246 20.144 10.514 13.874 28.195-19.125 54.91-42.797 67.372-75.56 10.593-27.747 10.827-58.395 3.35-86.926-4.284-16.225-11.294-31.51-20.563-45.54-2.648-3.919-8.645-4.389-12.15-1.645z'
			/>
		</svg>
	);
}

export default RightBackgroundPattern;
